var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0_25_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_25_16",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_25_16",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_25_16",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAkRJREFUeJzt2E+ITVEcB/Df8Sd/FkhJkrBBsWAjlrLSbPxpipVSyoK1JGUvpSyUDWVjwyClLChZshibCaUhFmoUaTDjz8fiWfnz7p3x7j0z0/ksX+e9+z3fe2/nvBNRFEVRFEVRFEVRFK1DwlE8xiBOYV7uXK3BCX96gCW5s7UC7/5SADzBytz5GoW5+PqPAmAYG3LnbBTudikARrAtd87GYA3eVJQwir7cWRuD1RiqKOEbDufO2hgsxcOKEn7gdO6sjcFC3K4oAc5jVu68jcBsXKxRwnXMz523ETq7w9M1SriHxbnzNgbH8L2ihJm9YcJefK4o4QXW5c7aGOzAh4oSRrB9or+dJhFmRUQsmOj3emB9RFyKiOVdxoxGRH9K6U7Pr44+vKq4C1PBGPrrzqvWE6Dzfg1GxHRZdj5FxOaU0vOqgXU3E3ti+kw+ImJhROyuM7BuASafJZtamesWcCMivkw+S+s+RcTNOgNrFZBSehYR+yLi5X+EasvXiDhU5/2PmF7L4LKIuBwR3U6IxiLiQEppoJVEbcFaPK9Y/j5iZ+6sPYeNeF0x+bfYkjtrz2Grzha3m2Ez8X8Adv56rLsZwqrcWXsO+zFeMflHWJY7a8/hiOozgPtYlDtrz+F4xcThFnIsw83ROQI7U2PyVzAnd96ew4Uakz+LCW/cpjydc4YqJ3PnbAzOdZn4dxxp8vpT4X1694/PxyPiYErpapthWocVeP/bnR/FrtzZWoP1uIanGMCm3JmKoiiKoiiKoiiKmewnFObeFiX09r4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow_right_white.2daed8930bfabc30889fd61c03e7add6.svg";
export { ForwardRef as ReactComponent };